import _ from 'lodash'

export default function (err) {
  const message = _.get(err, 'response.data.message')
  const error = _.get(err, 'response.data.error')
  const data = _.get(err, 'response.data')

  return message || error || data || 'Server Error'
}
